module.exports = __webpack_public_path__ + "static/media/icon_71.26fe205e.svg";